import { api } from "../../api";
import { UsersResponse } from "./types";

export async function deleteUserApi(userId: number): Promise<void> {
  await api.delete<UsersResponse>(`/api/users/${userId}`);
}

export async function editUserRoleApi(params: {
  userId: number;
  role: string;
  first_name: string;
  last_name: string;
  office_ids?: number[];
  warehouse_ids?: number[];
}): Promise<void> {
  await api.patch<UsersResponse>(`/api/users/${params.userId}`, {
    role: params.role,
    first_name: params.first_name,
    last_name: params.last_name,
    office_ids: params.office_ids,
    warehouse_ids: params.warehouse_ids,
  });
}

export async function restoreUserApi(userId: number): Promise<void> {
  await api.post<UsersResponse>(`/api/users/${userId}/restore`);
}
